/** The text style every value filled onto the generated I-9 uses, in both generators. */
export const fillTextStyle = {
  fontVariant: 'normal',
  fontWeight: 1000,
  fontStretch: 'normal',
  fontSize: '9px',
  fontFamily: 'Arial',
  fill: '#231f20',
  fillOpacity: 1,
  stroke: 'none',
};

// The statement under the Section 2 signature that the form was signed electronically, secondary
// to the signature itself and small enough not to reach the Today's Date cell.
export const signatureNoteStyle = {
  ...fillTextStyle,
  fontSize: '7px',
  fontWeight: 400,
};

// The Additional Information box holds several notes, so they print smaller than a field value.
export const additionalInformationStyle = {
  ...fillTextStyle,
  fontSize: '7px',
  fontWeight: 400,
};
